import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-497c807f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "organization-edition-page" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "organization-edition-page__title" }, " Редактирование данных организации ", -1))

import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { WOrganizationEditionForm } from '@/widgets/WOrganizationEditionForm'
import { FDownloadOrganizationHistory } from '@/features/FDownloadOrganizationHistory'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute()
const organizationId = computed(() => Number(route.params.organizationId))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_unref(WOrganizationEditionForm)),
    _createVNode(_unref(FDownloadOrganizationHistory), { "organization-id": _unref(organizationId) }, null, 8, ["organization-id"])
  ]))
}
}

})